import { render, staticRenderFns } from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=template&id=8328b4ba&scoped=true&lang=pug"
import script from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=script&lang=js"
export * from "./ModalResultadoDiagnosticoPessoaOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8328b4ba",
  null
  
)

export default component.exports